import { render } from "./beforeAfterThree.vue?vue&type=template&id=7fe46f54"
import script from "./beforeAfterThree.vue?vue&type=script&lang=js"
export * from "./beforeAfterThree.vue?vue&type=script&lang=js"

import "./beforeAfterThree.vue?vue&type=style&index=0&id=7fe46f54&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__